<div class="alerts-container">
  <mat-toolbar
    *ngFor="let alert of headerAlerts$ | async"
    class="header-alert {{ alert.theme }}"
  >
    <div class="content-container">
      <div class="text">
        <emperor-icon
          *ngIf="alert.iconName"
          [name]="alert.iconName"
          [title]="alert.iconName"
          class="resize-icon"
        ></emperor-icon>
        <span [innerHTML]="alert.message"></span>
      </div>
      <div class="buttons">
        <button
          mat-button
          *ngFor="let button of alert.buttons"
          [attr.role]="button.role"
          (click)="alertButtonClick(alert, button)"
        >
          {{ button.text }}
        </button>
      </div>
    </div>
  </mat-toolbar>
</div>
